export default __webpack_public_path__ + "static/media/redirect.d092d887.svg";